export const MAIN_URL = process.env.REACT_APP_MAIN_URL
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL
export const IDENTITY_API = `${MAIN_URL}/identity-service`
export const INDEX_API = `${MAIN_URL}/index-service`
export const PARTICIPANT_API = `${MAIN_URL}/participant-service`
export const PAM_API = `${MAIN_URL}/pam-service`
export const SETTINGS_API = `${MAIN_URL}/settings-service`
export const UPLOAD_API = `${MAIN_URL}/upload-service`
export const RECEIPTS_API = `${MAIN_URL}/receipts-service`
export const DESCRIPTION_API = `${MAIN_URL}/description-service`
export const REWARDS_API = `${MAIN_URL}/rewards-service`
export const OCR_API = `${MAIN_URL}/ocr-service`
